<form #form="ngForm">
  <spk-tabs>
    <spk-tab [name]="'inputs'"></spk-tab>
    <spk-tab [name]="'controls'"></spk-tab>
    <spk-tab [name]="'layouts'"></spk-tab>
  </spk-tabs>
  <spk-tab-panes>
    <spk-tab-pane [name]="'inputs'">
      <div class="row">
        <div class="col-md-4">
          <spk-card [title]="'Demo'" [meta]="'inputs'">
            <spk-text [name]="'text'" [(model)]="someModel.someString"></spk-text>
            <spk-textarea [name]="'textArea'" [(model)]="someModel.someString"></spk-textarea>
            <spk-password [name]="'password'" [(model)]="someModel.somePasswordString"></spk-password>
            <spk-number [name]="'number'" [(model)]="someModel.someNumber"></spk-number>
            <spk-currency [name]="'currency'" [(model)]="someModel.someNumber"></spk-currency>
            <spk-percent [name]="'percent'" [(model)]="someModel.somePercentFactor"></spk-percent>
            <spk-quantity [max]="10" [min]="0" [name]="'quantity'" [(model)]="someModel.someOtherNumber"></spk-quantity>
            <spk-date [name]="'dateDto'" [(model)]="someModel.someDateDto"></spk-date>
            <spk-checkbox [name]="'checkbox'" [(model)]="someModel.someBoolean"></spk-checkbox>
            <spk-select [name]="'someSelectionId'" [(model)]="someModel.someSelectionId" [options]="someOptions" [optionTextProperty]="'Text'" [optionValueProperty]="'Value'"></spk-select>
          </spk-card>
        </div>
        <div class="col-md-4">
          <spk-card [title]="'Output'" [meta]="'inputs'">
            <code>
                  <pre>{{someModel |json}}</pre>
              </code>
          </spk-card>
        </div>
      </div>
    </spk-tab-pane>
    <spk-tab-pane [name]="'controls'">
      <spk-card [title]="'Search Grid'" [meta]="'control'">
        <spk-search-grid [defaultSortProperty]="'Id DESC'" [list]="'ExampleSearchRow'"></spk-search-grid>
      </spk-card>
      <hr />
      <spk-card [title]="'Lookup'" [meta]="'control'">
        <spk-lookup [label]="'Example Lookup'" [id]="'bling'" [inputFormat]="inputFormat" [(selectedResult)]="lookupSelectedResult" [list]="'ExampleSearchRow'" [title]="'Example Lookup'"
          [sort]="'DisplayText, Value'">
        </spk-lookup>
      </spk-card>
      <hr />
      <spk-card [title]="'Value Text Selection Checklist'" [meta]="'control'">
        <spk-value-text-checkboxlist [(model)]="someValueTextSelectionItems"></spk-value-text-checkboxlist>
      </spk-card>
      <hr />
    </spk-tab-pane>
    <spk-tab-pane [name]="'layouts'">
      <spk-card [title]="'A Nice Title'" [meta]="'some meta text'" [class]="'col-md-3'">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio itaque laboriosam omnis culpa! Quia, qui omnis deserunt voluptatibus molestiae velit quo optio voluptas
          voluptatem!
          Quaerat, iure? Ipsum voluptatem veniam cumque.</p>
      </spk-card>
      <spk-card [title]="'Another Nice Title'" [meta]="'more meta'" [class]="'col-md-5'">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio itaque laboriosam omnis culpa! Quia, qui omnis deserunt voluptatibus molestiae velit quo optio voluptas
          voluptatem!
          Quaerat, iure? Ipsum voluptatem veniam cumque.</p>
      </spk-card>
      <spk-card [title]="'A SEQUEL TO Another Nice Title'" [meta]="'the sequel'" [class]="'col-md-8'">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio itaque laboriosam omnis culpa! Quia, qui omnis deserunt voluptatibus molestiae velit quo optio voluptas
          voluptatem!
          Quaerat, iure? Ipsum voluptatem veniam cumque.</p>
      </spk-card>
    </spk-tab-pane>
  </spk-tab-panes>
</form>